export default {
    email: "Email",
    required: "Your email is required",
    valid: "Please enter a valid email address",
};
